import { useContext } from 'react';
import { AiAgentContext } from './AgentDetailPageComponent';
import { AgentLayoutComponent } from './AgentLayoutComponent';

export const AgentLayoutViewComponent = () => {

    const { state: { ai_agent } } = useContext(AiAgentContext);

    return (
        <AgentLayoutComponent id="agent_layout" messages={[]} agent={ai_agent} />
    );
};
